// src/components/PaginationEllipsis.js
import React, { useEffect, useState } from 'react';
import Pagination from 'react-bootstrap/Pagination';

const PaginationEllipsis = ({ page, totalPages, onPageChange }) => {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' ? window.innerWidth < 576 : false
    );

    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const handleResize = () => {
            setIsMobile(window.innerWidth < 576);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const maxDisplayed = isMobile ? 5 : 7;
    const pages = [];

    const createItem = (p, label = null) => (
        <Pagination.Item
            key={p}
            active={p === page}
            onClick={() => onPageChange(p)}
        >
            {label || p}
        </Pagination.Item>
    );

    if (totalPages <= maxDisplayed) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(createItem(i));
        }
    } else {
        if (isMobile) {
            if (page <= 2) {
                for (let i = 1; i <= 3; i++) pages.push(createItem(i));
                pages.push(<Pagination.Ellipsis key="e1m" disabled />);
                pages.push(createItem(totalPages));
            } else if (page >= totalPages - 1) {
                pages.push(createItem(1));
                pages.push(<Pagination.Ellipsis key="e2m" disabled />);
                for (let i = totalPages - 2; i <= totalPages; i++) pages.push(createItem(i));
            } else {
                pages.push(createItem(1));
                pages.push(<Pagination.Ellipsis key="e3m" disabled />);
                pages.push(createItem(page));
                pages.push(<Pagination.Ellipsis key="e4m" disabled />);
                pages.push(createItem(totalPages));
            }
        } else {
            if (page <= 4) {
                for (let i = 1; i <= 5; i++) pages.push(createItem(i));
                pages.push(<Pagination.Ellipsis key="e1" disabled />);
                pages.push(createItem(totalPages));
            } else if (page >= totalPages - 3) {
                pages.push(createItem(1));
                pages.push(<Pagination.Ellipsis key="e2" disabled />);
                for (let i = totalPages - 4; i <= totalPages; i++) pages.push(createItem(i));
            } else {
                pages.push(createItem(1));
                pages.push(<Pagination.Ellipsis key="e3" disabled />);
                pages.push(createItem(page - 1));
                pages.push(createItem(page));
                pages.push(createItem(page + 1));
                pages.push(<Pagination.Ellipsis key="e4" disabled />);
                pages.push(createItem(totalPages));
            }
        }
    }

    return (
        <Pagination className="justify-content-center flex-nowrap mb-0">
            <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={page === 1} />
            {pages}
            <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={page === totalPages} />
        </Pagination>
    );
};

export default PaginationEllipsis;
